const Paan = () => {
	return (
		<div class="menu">
			<img
				src="https://ik.imagekit.io/manav11goyal11/family-chaat/menu/Paan-1.jpg"
				alt="Paan"
			/>
			<img
				src="https://ik.imagekit.io/manav11goyal11/family-chaat/menu/Paan-2.jpg"
				alt="Paan"
			/>
			<img
				src="https://ik.imagekit.io/manav11goyal11/family-chaat/menu/Paan-3.jpg"
				alt="Paan"
			/>
			<img
				src="https://ik.imagekit.io/manav11goyal11/family-chaat/menu/Paan-4.jpg"
				alt="Paan"
			/>
			<img
				src="https://ik.imagekit.io/manav11goyal11/family-chaat/menu/Paan-5.jpg"
				alt="Paan"
			/>
			<img
				src="https://ik.imagekit.io/manav11goyal11/family-chaat/menu/Paan-6.jpg"
				alt="Paan"
			/>
		</div>
	);
};

export default Paan;
